<template>

</template>

<script>
export default {
  name: "DeleteWhitelist"
}
</script>

<style scoped>

</style>